// Don't need to call WCS again when changing productColour as we already have all the necessary data
// however this means need to set correct selected productColour based on appState

/* Keep */
export const getProductColours = ({ productColours }, selectedPartNumber) => {
    return productColours.reduce((colours, colour) => {
        const { displayable, banned, partNumber, selected: isSelectedFromResponse, visible: isVisible } = colour;
        const selected = selectedPartNumber ? partNumber === selectedPartNumber : isSelectedFromResponse;
        const isNotSelectedAndNotVisible = !isSelectedFromResponse && !isVisible;

        if (!displayable || isNotSelectedAndNotVisible || banned) return colours;

        return [...colours, { ...colour, selected }];
    }, []);
};
